import { DailyItem } from './dailyitem'

export const Sunday = new DailyItem({
  id: '5d436ad1-1c1d-4d50-b5df-4a602f0db2e3',
  name: 'sunday',
  label: 'Sunday',
  value: 0,
})
export const Monday = new DailyItem({
  id: 'f9e74de6-7034-4182-b152-f6a3dd1028b3',
  name: 'monday',
  label: 'Monday',
  value: 1,
})
export const Tuesday = new DailyItem({
  id: 'c5f7df82-e6b9-4dd0-8969-9cfcf989a1b9',
  name: 'tuesday',
  label: 'Tuesday',
  value: 2,
})
export const Wednesday = new DailyItem({
  id: '786d8f67-4aae-471d-b7f5-bbd2b074beab',
  name: 'wednesday',
  label: 'Wednesday',
  value: 3,
})
export const Thursday = new DailyItem({
  id: '73a25b4b-dc3b-4ac2-9a81-64f3decf38ed',
  name: 'thursday',
  label: 'Thursday',
  value: 4,
})
export const Friday = new DailyItem({
  id: 'f3cf8cb2-53cc-4438-a8db-4f50087e15cd',
  name: 'friday',
  label: 'Friday',
  value: 5,
})
export const Saturday = new DailyItem({
  id: '6f7771f8-a820-4547-9eaa-75e1b5dd2c64',
  name: 'saturday',
  label: 'Saturday',
  value: 6,
})
